<template>
  <div class="das-dropdown" @click.stop="toggleList()">
    {{ editInput ? editInput : defaultDropdownText[defaultText] }}
    <span class="milestone-count" v-if="inputArrCount && inputArrCount > 1">{{ inputArrCount }}</span>
    <span class="caret"></span>
    <ul :class="{ 'display-block': showList, 'display-none': !showList }">
      <li :class="{ 'display-block': showList, 'display-none': !showList }" v-for="(opt, index) in options" :key="index" @click.stop=""><input type="checkbox" :value="opt.milestoneId" @click.stop="" @change.stop="selectedData(opt)" v-model="selectedDataIDsArr" />{{ displayOptionText(opt) }}</li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "das-dropdown-multi-checkbox",
  props: {
    options: {
      type: Array,
      default: () => []
    },
    optionField: {
      type: String,
      default: ""
    },
    valueField: {
      type: String,
      default: ""
    },
    defaultText: {
      type: String,
      default: null
    },
    input: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      default: ""
    },
    id: {
      type: String,
      required: false,
      default: null
    }
  },
  data() {
    return {
      defaultDropdownText: {
        trigger: "Select Trigger",
        participantInfo: "Select a Field",
        milestone: "Select Milestone(s)",
        language: "Select Language(s)",
        birthDate: "Select a Date",
        country: "Select a Country",
        gender: "Select Gender"
      },
      showList: false,
      selectedText: null,
      selectedDataIDsArr: [],
      selectedDataArr: [],
      inputArrCount: null
    };
  },
  created() {
    this.$root.$on("close-all-drop-downs", data => {
      if (data == "all" || data !== this.id) {
        this.showList = false;
      }
    });
  },
  computed: {
    editInput() {
      this.updateSelectedText();
      return this.selectedText;
    },
    ...mapGetters(["getDynamicSchedulingServiceData"])
  },
  methods: {
    updateSelectedText() {
      this.selectedText = "";
      if (this.input) {
        const selectedObj = this.input;
        if (selectedObj.length == 1) {
          this.selectedText = selectedObj[0]["displayName"] + " - Study Day " + this.getDynamicSchedulingServiceData.getDisplayMilestoneDay(selectedObj[0]["milestoneDay"]);
        } else if (selectedObj.length > 1) {
          this.selectedText = "Selected Milestones";
        }
        this.inputArrCount = selectedObj.length;
        this.selectedDataIDsArr = this.convertDataListToIdList(this.input, "milestoneId");
      }
    },
    toggleList() {
      this.showList = !this.showList;
      this.$root.$emit("close-all-drop-downs", this.id); // this will close only single dropdown( single )
    },
    selectedData(data) {
      this.showList = true;
      this.selectedText = data[this.optionField];
      this.selectedDataArr = this.convertIdListToDataList(this.options, this.selectedDataIDsArr, "milestoneId");
      this.$emit("selected-data", this.selectedDataArr);
    },
    displayOptionText(option) {
      if (this.type === "Milestone") {
        return option["milestoneName"] + " - Study Day " + this.getDynamicSchedulingServiceData.getDisplayMilestoneDay(option["milestoneDay"]);
      }
      return "";
    },
    convertDataListToIdList(list, key) {
      return list && list.map(val => val[key]);
    },
    convertIdListToDataList(list, IdList, key) {
      const finalList = [];
      for (const data of list) {
        for (const id of IdList) {
          if (data[key] === id) {
            finalList.push(data);
            break;
          }
        }
      }
      return finalList;
    }
  }
};
</script>

<style lang="scss" scoped>
.display-block {
  display: block;
}

.display-none {
  display: none;
}

.dd-placeholder {
  color: #b0bac9;
  font-size: 13px;
  padding: 7px 17px !important;
  font-weight: normal;
}

.das-dropdown {
  border: solid 1px #d3dfe4;
  padding: 6px 17px;
  border-radius: 3px;
  position: relative;
  cursor: pointer;
  margin-bottom: 15px;

  .milestone-count {
    color: #4c8ce4;
    background-color: #d3dfe4;
    padding: 0.2px 6px 1px 5.5px;
    border-radius: 2px;
    margin-left: 9px;
    font-size: 12px;
    font-weight: 600;
    position: absolute;
    top: 7px;
  }

  .caret {
    width: 0;
    height: 0;
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    border-top: 6px solid #b0bac9;
    top: 14px;
    right: 7px;
    position: absolute;
  }

  ul {
    font-family: RobotoRegular;
    font-size: 15px;
    margin: 0;
    padding: 10px 0;
    list-style: none;
    position: absolute;
    z-index: 9;
    top: 0;
    width: 100%;
    max-height: 200px;
    overflow-y: auto;
    left: 0;
    /* box-shadow: 0 1px 0px 0 rgba(230, 230, 230 , 2%), 0 1px 9px 0 rgba(230, 230, 230 , 100%); */
    box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.25);
    background-color: #fff;

    li {
      display: block;
      text-decoration: none;
      color: #000;
      /* border-top: 1px solid #ffffff; */
      padding: 5px 15px 6px 15px;
      background: #ffffff;
      margin-left: 1px;
      white-space: nowrap;

      input[type="checkbox"] {
        box-sizing: border-box;
        cursor: pointer;
        padding: 0;
        margin-right: 11px;
        margin-top: auto;
        margin-bottom: auto;
        top: 3px;
        bottom: 0px;
        position: relative;
        width: 16px;
        height: 16px;
        border-radius: 4px;
        outline: solid 1px #e2e7ea;
        border: none;
      }

      &:hover {
        background: rgba(0, 0, 0, 0.025);
      }
    }
  }

  ul::-webkit-scrollbar-thumb {
    background-color: #c4c4c4;
    border-radius: 4px;
    height: 50px;
    border: 3px solid transparent;
  }

  ul::-webkit-scrollbar-track {
    background: transparent;
  }

  ul::-webkit-scrollbar {
    width: 4px;
  }
}
</style>
